import * as tslib_1 from "tslib";
import { SpecularCompositeMethod } from "./SpecularCompositeMethod";
/**
 * SpecularFresnelMethod provides a specular shading method that causes stronger highlights on grazing view angles.
 */
var SpecularFresnelMethod = (function (_super) {
    tslib_1.__extends(SpecularFresnelMethod, _super);
    /**
     * Creates a new SpecularFresnelMethod object.
     * @param basedOnSurface Defines whether the fresnel effect should be based on the view angle on the surface (if true), or on the angle between the light and the view.
     * @param baseMethod The specular method to which the fresnel equation. Defaults to SpecularBasicMethod.
     */
    function SpecularFresnelMethod(basedOnSurface, fresnelPower, normalReflectance, baseMethod) {
        if (basedOnSurface === void 0) { basedOnSurface = true; }
        if (fresnelPower === void 0) { fresnelPower = 5; }
        if (normalReflectance === void 0) { normalReflectance = 0.028; }
        if (baseMethod === void 0) { baseMethod = null; }
        var _this = _super.call(this, baseMethod) || this;
        _this._basedOnSurface = basedOnSurface;
        _this._fresnelPower = fresnelPower;
        _this._normalReflectance = normalReflectance;
        return _this;
    }
    Object.defineProperty(SpecularFresnelMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return SpecularFresnelMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpecularFresnelMethod.prototype, "basedOnSurface", {
        /**
         * Defines whether the fresnel effect should be based on the view angle on the surface (if true), or on the angle between the light and the view.
         */
        get: function () {
            return this._basedOnSurface;
        },
        set: function (value) {
            if (this._basedOnSurface == value)
                return;
            this._basedOnSurface = value;
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpecularFresnelMethod.prototype, "fresnelPower", {
        /**
         * The power used in the Fresnel equation. Higher values make the fresnel effect more pronounced. Defaults to 5.
         */
        get: function () {
            return this._fresnelPower;
        },
        set: function (value) {
            if (this._fresnelPower == value)
                return;
            this._fresnelPower = value;
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpecularFresnelMethod.prototype, "normalReflectance", {
        /**
         * The minimum amount of reflectance, ie the reflectance when the view direction is normal to the surface or light direction.
         */
        get: function () {
            return this._normalReflectance;
        },
        set: function (value) {
            if (this._normalReflectance == value)
                return;
            this._normalReflectance = value;
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    return SpecularFresnelMethod;
}(SpecularCompositeMethod));
export { SpecularFresnelMethod };
SpecularFresnelMethod.assetType = "[asset SpecularFresnelMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/SpecularFresnelMethod.js